<template>
  <div class="city-bank__search-box city-bank__search-box--inline">
    <div class="d-flex justify-content-end">
      <label class="visually-hidden"
             for="searchInput">Search input</label>
      <input type="text"
             v-model="searchInput"
             placeholder="Search"
             class="form-control"
             :class="{ active: isActive }"
             id="searchInput"
             name="searchInput" />
      <a href="javascript:void(0)"
         role="button"
         @click="handleSearchCLick"
         aria-label="Close Search"
         :class="{ active: isActive }"
         class="search-close__button btn btn-primary p-1 px-3">
        <svg v-show="!loading" class="heroicon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
        <div class="spinner-border text-white"
             role="status"
             v-show="loading">
          <span class="visually-hidden">Loading...</span>
        </div>
      </a>
    </div>
    <div class="search-modal__inner" :class="{ active: isInnerActive }">
      <ul class="list-unstyled m-0"
          v-show="!loading">
        <li v-for="(item, index) in results"
            :key="`search-result__${index}`">
          <div v-html="item"></div>
        </li>
      </ul>
      <div class="d-flex justify-content-center"></div>
    </div>
  </div>
</template>
<script>
  import { ref, onMounted, watchEffect, computed } from 'vue';
  import axios from 'axios';
  import { debounceInput } from '../helpers/debounce';
  import { useGtm } from "@gtm-support/vue-gtm";

  export default {
    props: {
      url: {
        type: String,
        required: true
      },
      id: {
        type: String,
        required: true
      },
      index: {
        type: String,
        required: true
      },
      fields: {
        type: String,
        required: true
      },
      language: {
        type: String,
        required: true
      }
    },
    setup(props) {
      console.log(props)
      const results = ref([]);
      const searchInput = ref('');
      const loading = ref(false);
      const isActive = ref(false);
      const isInnerActive = computed(() => results.value.length > 0);
      const dialogClass = 'modal-lg';
      const modalClass = 'fade';
      const options = {
        backdrop: false,
        keyboard: true,
        focus: false
      };
      const gtm = useGtm();

      const handleMount = (modalEvent) => {
      };

      const openModal = () => {
        results.value = [
        ];
      };

      const closeModal = () => {
        results.value = [];
        searchInput.value = "";
        isActive.value = false;
      };

      const handleSearchCLick = () => {
        isActive.value = true;
      }

      let timer;

      const debouncedGtmEvent = (config, timeout = 2000) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => gtm.trackEvent(config), timeout);
      }

      const getResults = debounceInput((query) => {
        const route = `${props.url}?IndexName=${props.index}&SuggestionFields=${props.fields}&Text=${query}&Language=${props.language}&SiteId=${props.id}`;
        axios.get(route)
          .then((response) => {
            if (!response.data.Suggestions.length) {
              results.value = [
                '<p>No results match your search query, please try again.</p>'
              ];
            } else {
              results.value = response.data.Suggestions
            }
            loading.value = false;
            debouncedGtmEvent({
              event: "search",
              category: "Website search",
              action: document.title,
              label: query,
              value: response.data.Suggestions.length,
              noninteraction: false,
            });
          })
          .catch((error) => {
            console.log(error);
            loading.value = false;
          });
      });

      const search = (query) => {
        if (query.length) {
          loading.value = true;
          getResults(query);
        }
      };

      watchEffect(
        () => search(searchInput.value)
      );

      onMounted(() => {
        // handle clicking outside of the modal
        const modalElement = document.querySelector('.city-bank__search-box');
        document.addEventListener('click', (event) => {

          const outsideClick = event.target instanceof Element &&
            modalElement.contains(event.target)

          if (!outsideClick) {
            event.stopPropagation();
            closeModal();
          }
        });
      });

      return {
        results,
        searchInput,
        search,
        openModal,
        closeModal,
        loading,
        dialogClass,
        modalClass,
        handleMount,
        options,
        handleSearchCLick,
        isActive,
        isInnerActive 
      };
    }
  }
</script>
